/**
 * useOrphanActivityCount — compteur orphelins RFID OK / Rawdata No (FEAT-RECON-CONTROL-PANEL).
 * Compte uniquement les PENDING isClosed=false (PDV ouverts à investiguer).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchOrphanActivityCount } from '../lib/api';

export function useOrphanActivityCount(batchId: string | undefined) {
  return useQuery({
    queryKey:  ['admin', 'orphan-activity-count', batchId],
    queryFn:   () => fetchOrphanActivityCount(batchId!),
    enabled:   Boolean(batchId),
    staleTime: 30_000,
    retry:     1,
  });
}
